import React from "react";
import { FileRejection } from "react-dropzone";

import { CheckMarkIcon } from "../../components/icons/themes/materialdesign";

export type SelectedFileDetailsProps = {
  acceptedFile: File | null | undefined;
  rejectedFile: FileRejection | null | undefined;
};

function AcceptedFileDetails({ acceptedFile }: { acceptedFile: File }) {
  return (
    <div className="text-sm m-1" key={acceptedFile.name}>
      {acceptedFile.name} - {acceptedFile.size} bytes
      <CheckMarkIcon className="ml-1 text-green-800" />
    </div>
  );
}

function RejectedFileDetails({
  rejectedFile,
}: {
  rejectedFile: FileRejection;
}) {
  const err = rejectedFile.errors[0];

  return (
    <div className="text-sm m-1 text-red-400" key={err.code}>
      {err.message}
    </div>
  );
}

function SelectedFileDetails({
  acceptedFile,
  rejectedFile,
}: SelectedFileDetailsProps) {
  if (acceptedFile) {
    return <AcceptedFileDetails acceptedFile={acceptedFile} />;
  } else if (rejectedFile) {
    return <RejectedFileDetails rejectedFile={rejectedFile} />;
  } else {
    return <div className="text-sm m-1">&nbsp;</div>;
  }
}

export default SelectedFileDetails;
